import { Check, ContentCopy } from '@mui/icons-material';
import {
  // eslint-disable-next-line no-restricted-imports
  Button,
  IconButton,
  InputAdornment,
  TextField,
  type ButtonProps,
  type IconButtonProps,
  type TextFieldProps,
} from '@mui/material';
import type { PropsWithChildren } from 'react';
import useCopyText from '~/hooks/useCopyText';

interface CopyInputButtonProps extends Omit<TextFieldProps, 'value'> {
  value: string | number;
}
interface CopyIconButtonProps extends Omit<IconButtonProps, 'value'> {
  value: string | number;
}
interface CopyButtonProps extends Omit<ButtonProps, 'value' | 'href'> {
  value: string | number;
}
export const CopyIconButton = ({
  value,
  size,
  ...props
}: CopyIconButtonProps) => {
  const { copied, copy } = useCopyText((value || '').toString());

  return (
    <IconButton onClick={copy} title="Copy to clipboard" {...props}>
      {copied ? (
        <Check color="success" fontSize={size} />
      ) : (
        <ContentCopy color="primary" fontSize={size} />
      )}
    </IconButton>
  );
};

export const CopyButton = ({
  value,
  size,
  children,
  ...props
}: PropsWithChildren<CopyButtonProps>) => {
  const { copied, copy } = useCopyText((value || '').toString());

  return (
    <Button
      onClick={copy}
      title="Copy to clipboard"
      startIcon={
        copied ? <Check fontSize={size} /> : <ContentCopy fontSize={size} />
      }
      {...props}>
      {children}
    </Button>
  );
};

export const CopyInputButton = ({ value, ...props }: CopyInputButtonProps) => {
  return (
    <TextField
      value={value}
      disabled
      {...props}
      slotProps={{
        input: {
          ...props.slotProps?.input,
          endAdornment: (
            <InputAdornment position="end">
              <CopyIconButton value={value} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
